import React from "react";

const DetailRow = ({ icon, label, value }) => (
  <div className="qp-detail-row">
    <span className="qp-detail-label">
      <span className="qp-detail-icon">{icon}</span>
      {label}
    </span>
    <span className="qp-detail-value">{value}</span>
  </div>
);

export default DetailRow;

